import React, { FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { SelectBox } from 'components/Form'
import { DefaultStockType } from 'types/schedule'
import { useSelector } from 'react-redux'
import { getOpenTime, getLastPickupTime } from 'reducks/store/selectors'
import { State } from 'index'
import { DeleteIconButton } from 'components/Button'
import { useTimesWithRange } from 'hooks/store'
import { useStockAmountOptions } from 'hooks/stock'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { BusinessTimeType, OpenTimeType } from 'types/store'
import { useEarliestBusinessTime, useLatestOpenTime } from 'hooks/businessHour'
import { useGetTemporaryOpen } from 'hooks/storeCalendar'
import { getStoreCalendars } from 'reducks/storeCalendar/selectors'
import { StockUnionType } from 'types/stock'
import { dateToString } from 'lib/helper'

type Props = {
  date: Date
  daysOfWeek: DayOfWeekType[]
  defaultStocks: DefaultStockType[]
  deleteDefaultStock: (index: number) => void
  handleDefaultStocks: (defaultStock: DefaultStockType, index: number) => void
  type: StockUnionType
}

const IndividualStockForm: FC<Props> = (props) => {
  const { date, daysOfWeek, defaultStocks, deleteDefaultStock, handleDefaultStocks, type } = props

  const openTime: OpenTimeType = useSelector((state: State) => getOpenTime(state))
  const lastPickupTime: BusinessTimeType = useSelector((state: State) => getLastPickupTime(state))
  const storeCalendars = useSelector((state: State) => getStoreCalendars(state))
  // 選択した日付の臨時営業日データ（通常営業日ならundefined）
  const temporaryOpen = useGetTemporaryOpen(dateToString(date), storeCalendars)
  const latestOpenTime = useLatestOpenTime(daysOfWeek, openTime, temporaryOpen)
  const earliestLastPickupTime = useEarliestBusinessTime(daysOfWeek, lastPickupTime, 'last_pickup_time', temporaryOpen)
  const pickupableTimeOptions = useTimesWithRange(latestOpenTime, earliestLastPickupTime)

  const selectPickupableTime = (pickupableTime: string, index?: number) => {
    if (typeof index === 'undefined') return
    handleDefaultStocks(
      {
        pickupable_time: pickupableTime,
        stock: defaultStocks[index].stock,
      },
      index
    )
  }

  const selectStock = (stock: string, index?: number) => {
    if (typeof index === 'undefined') return
    handleDefaultStocks(
      {
        pickupable_time: defaultStocks[index].pickupable_time,
        stock: Number(stock),
      },
      index
    )
  }

  const stockOptions = useStockAmountOptions()

  return (
    <div>
      <div className={styles.column_two}>
        <div className={`${styles.column_two__item} ${text.font_small}`}>受渡解禁時刻</div>
        <Spacer size={8} />
        <div className={`${styles.column_two__item} ${text.font_small}`}>
          <span>1日の販売上限数</span>
        </div>
        <Spacer size={32} axis={'horizontal'} />
      </div>
      <Spacer size={8} />
      {defaultStocks.map((defaultStock, defaultStockIndex) => {
        return (
          <React.Fragment key={`${defaultStock.pickupable_time}-${defaultStockIndex}`}>
            <div className={styles.column_two}>
              <div className={styles.column_two__item}>
                <SelectBox
                  index={defaultStockIndex}
                  options={pickupableTimeOptions}
                  select={selectPickupableTime}
                  value={defaultStock.pickupable_time}
                />
              </div>
              <Spacer size={8} />
              <div className={styles.column_two__item}>
                <SelectBox
                  index={defaultStockIndex}
                  options={stockOptions}
                  select={selectStock}
                  value={String(defaultStock.stock)}
                />
              </div>
              <Spacer size={8} />
              <DeleteIconButton
                disabled={defaultStocks.length === 1}
                onClick={() => deleteDefaultStock(defaultStockIndex)}
              />
            </div>
            {defaultStockIndex !== defaultStocks.length - 1 && <Spacer size={8} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default IndividualStockForm
